/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './nonce.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/components/nonce/nonce.component';
import * as i3 from '@angular/router';
import * as i4 from '../../../../app/services/auth.service';
import * as i5 from '../../../../app/services/email.service';
import * as i6 from '../../../../app/services/log.service';
import * as i7 from '../../../../app/services/organization.service';
import * as i8 from '../../../../app/services/perf.service';
import * as i9 from '../../../../app/services/user.service';
const styles_NonceComponent:any[] = [i0.styles];
export const RenderType_NonceComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NonceComponent,data:{}});
export function View_NonceComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'section',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n	'])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      1,'p',[['style','margin: 1em;']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['Registering Device'])),(_l()(),
      i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (null as any),(null as any));
}
export function View_NonceComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'nonce',([] as any[]),
      (null as any),(null as any),(null as any),View_NonceComponent_0,RenderType_NonceComponent)),
      i1.ɵdid(1,4308992,(null as any),0,i2.NonceComponent,[i3.Router,i3.ActivatedRoute,
          i4.AuthService,i5.EmailService,i6.LogService,i7.OrganizationService,i8.PerfService,
          i9.UserService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const NonceComponentNgFactory:i1.ComponentFactory<i2.NonceComponent> = i1.ɵccf('nonce',
    i2.NonceComponent,View_NonceComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9ub25jZS9ub25jZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9jb21wb25lbnRzL25vbmNlL25vbmNlLmNvbXBvbmVudC50cyIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9ub25jZS9ub25jZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9ub25jZS9ub25jZS5jb21wb25lbnQudHMuTm9uY2VDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c2VjdGlvbj5cblx0PHAgc3R5bGU9XCJtYXJnaW46IDFlbTtcIj5SZWdpc3RlcmluZyBEZXZpY2U8L3A+XG48L3NlY3Rpb24+XG4iLCI8bm9uY2U+PC9ub25jZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQVM7YUFBQSw0QkFDUjtNQUFBO01BQUEsZ0JBQXdCLDBEQUFzQjthQUFBLDJCQUNyQzs7OztvQkNGVjtNQUFBO2FBQUE7O3dCQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/nonce/nonce.component.ngfactory.ts